import { swapFields } from '@/utils';

import { BPSymbol } from '../types';
import { OMIT_FROM_SHOW } from '../types/dimension';
import {
  FIELD_MP as MP,
  FIELD_ID as FID,
  FIELD_Z0 as Z0,
  LENGTH_STR_FIELD as LSF,
  FIELD_W1,
  FIELD_W2,
  FIELD_W3,
  FIELD_H1,
  FIELD_H2,
  FIELD_H3,
} from '../types/fields';
import { TKItemProperty } from '../types/entity';

type CommonCell = {
  /** current field */
  field: string;
  /** if this column is sortable */
  sortable?: boolean;
};

export type HeaderCell = {
  name: string;
} & CommonCell;

export type SymbolCell = {
  /** symbol internal id */
  id: string;
  /** `input` if true, otherwise plain div will be built  */
  editable: boolean;
  value: string | number;
  /** title for hover */
  title?: string;
  /** value type: 'string' | 'bar' | 'image' | 'button' */
  type: string;
  /** if this symbol validated manually */
  confirmed?: boolean;
  /** all dimension fields in table, will attach to `completion` cell */
  fields?: string[];
  /** symbol type: like `ELBOW` */
  class: string;
  /** if available to edit, determine `disabled` attribute of input */
  invisible?: boolean;
  /**
   * allow to focus on tab change, false by default
   * @deprecated
   */
  focusable?: boolean;
  /** item property definition */
  itemProperty?: TKItemProperty | null;
  /** drawing unit */
  unit?: string;
} & CommonCell;

export type SymbolRow = SymbolCell[];
export type ROWS = { row: SymbolRow; symbol: BPSymbol }[];

/**
 * do two this:
 * - setup a basice order for dimension fields
 * - exclude some invisible fields
 * @param fields
 * @returns
 */
export const tableFieldsOrder = (fields: string[]) => {
  const hiddenFields = OMIT_FROM_SHOW;
  const showCheck = (f: string) => !hiddenFields.includes(f);
  const orderedFields = [...fields].sort().filter(showCheck);
  return swapWidthsBeforeHeights(orderedFields);
};

/**
 * Alphabetical sort puts `height_N` before `width_N`; swap each pair so
 * width comes right before its matching height when both are present.
 */
const swapWidthsBeforeHeights = (fields: string[]) => {
  const pairs: [string, string][] = [
    [FIELD_H1, FIELD_W1],
    [FIELD_H2, FIELD_W2],
    [FIELD_H3, FIELD_W3],
  ];
  return pairs.reduce(
    (acc, [h, w]) =>
      acc.includes(h) && acc.includes(w) ? swapFields(acc, h, w) : acc,
    fields,
  );
};

/**
 * ! FINAL place to adjust fied order before display!
 * @date 2025/09/08
 *
 * Check length field to re-order the cell list.
 *
 * FIXME: Move `LSF` to the back if found
 * with the request of Simon
 * @date 2024/03/15
 *
 * another issue regarding `zone` field:
 * https://taksoai.atlassian.net/browse/TAK-918
 * @date 2025/10/23
 *
 * @param fields
 * @param cells
 */
export const putFieldToBack = (fields: string[], cells: CommonCell[]) => {
  const moveBack = (cells: CommonCell[], field: string) => {
    const targetFieldPos = cells.findIndex((sf) => sf.field == field);
    const [targetCell] = cells.splice(targetFieldPos, 1);
    cells.push(targetCell);
  };
  // ! add it as first tuning - 2025/10/23
  const hasZone = fields.includes(Z0);
  if (hasZone) {
    moveBack(cells, Z0);
  }
  const hasLSF = fields.includes(LSF);
  if (hasLSF) {
    moveBack(cells, LSF);
  }
  const hasIDF = fields.includes(FID);
  if (hasIDF) {
    moveBack(cells, FID);
  }
  const hasMPF = fields.includes(MP);
  if (hasMPF) {
    moveBack(cells, MP);
  }
};
